import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  SupplierOrderListReq,
  SupplierOrderListRes,
  ActionSupplierOrderRes,
  SupplierOrderDetailReq,
  SupplierOrderDetailRes,
  UpdateSupplierOrderStatusReq,
  CountRes,
} from './types'

export const getSupplierOrderListAction = createAsyncAction(
  'SUPPLIER_ORDER/GET_SUPPLIER_ORDER_LIST_REQ',
  'SUPPLIER_ORDER/GET_SUPPLIER_ORDER_LIST_SUCCESS',
  'SUPPLIER_ORDER/GET_SUPPLIER_ORDER_LIST_FAILURE',
)<SupplierOrderListReq, SupplierOrderListRes, Error>()

export const getSupplierOrderDetailAction = createAsyncAction(
  'SUPPLIER_ORDER/GET_SUPPLIER_ORDER_DETAIL_REQ',
  'SUPPLIER_ORDER/GET_SUPPLIER_ORDER_DETAIL_SUCCESS',
  'SUPPLIER_ORDER/GET_SUPPLIER_ORDER_DETAIL_FAILURE',
)<SupplierOrderDetailReq, SupplierOrderDetailRes, Error>()

export const updateSupplierOrderStatusAction = createAsyncAction(
  'SUPPLIER_ORDER/UPDATE_SUPPLIER_ORDER_STATUS_REQ',
  'SUPPLIER_ORDER/UPDATE_SUPPLIER_ORDER_STATUS_SUCCESS',
  'SUPPLIER_ORDER/UPDATE_SUPPLIER_ORDER_STATUS_FAILURE',
)<UpdateSupplierOrderStatusReq, ActionSupplierOrderRes, Error>()

export const getCountAction = createAsyncAction(
  'SUPPLIER_ORDER/GET_COUNT_REQ',
  'SUPPLIER_ORDER/GET_COUNT_SUCCESS',
  'SUPPLIER_ORDER/GET_COUNT_FAILURE',
)<{}, CountRes, Error>()

export const clearEventAction = createStandardAction('SUPPLIER_ORDER/CLEAR_EVENT')<void>()
